import { tableOfContentFlatMap } from '@doltech/ui/lib/figma/Layout/Landing/Content/TableOfContent/utils';
import { useTableOfContentScrollTracking } from '@doltech/ui/lib/figma/Layout/Landing/Content/useTableOfContentScrollTracking.hook';
import { useFromScreens } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import dynamic from 'next/dynamic';
import React from 'react';

const DesktopTableOfContent = dynamic<any>(
  () => import('./TableOfContentBase').then((mod) => mod.DesktopTableOfContent),
  { ssr: false }
);

const MobileTableOfContent = dynamic<any>(
  () => import('./TableOfContentBase').then((mod) => mod.MobileTableOfContent),
  { ssr: false }
);

export const TableOfContentGrammarLanding = (props) => {
  const { items, editorItems, scrollContainerElm } = props;
  const itemToCheck = items?.length ? items : editorItems;

  const sectionIds = React.useMemo(() => {
    return tableOfContentFlatMap(itemToCheck).map((item) => item.id);
  }, [itemToCheck]);

  const { currentSectionId } = useTableOfContentScrollTracking({
    sectionIds,
    scrollContainerElm,
    offsetY: 0,
  });

  const [, from1240] = useFromScreens([0, 1240]);

  if (from1240) {
    return <DesktopTableOfContent currentSectionId={currentSectionId} {...props} />;
  }
  return <MobileTableOfContent currentSectionId={currentSectionId} {...props} />;
};
